var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframeElement",staticStyle:{"width":"100%","height":"92vh"},attrs:{"src":_vm.mattermost,"allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }